import { useRef, useState } from "react";
import { isNil } from "lodash";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { fillTemplate, WORKSHOP_ICONS } from "./workshop-view";

const WorkshopNewState = ({ labels, busy, disabled, onPropose, onCancel }) => {
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);
  const ready = !disabled && (text.trim() !== "" || !isNil(file));

  const pickFile = ({ target }) => {
    const picked = target.files && target.files[0];
    target.value = null;
    if (picked) setFile(picked);
  };

  const submit = () => {
    if (!ready) return;
    onPropose({ text, file });
  };

  return (
    <section className="workshop-new-state" aria-label={labels.TITLE}>
      <div className="workshop-new-state__head">
        <strong>{labels.TITLE}</strong>
        <span>{labels.HINT}</span>
      </div>
      <textarea
        rows={3}
        className="workshop-new-state__text"
        aria-label={labels.LABEL}
        placeholder={labels.PLACEHOLDER}
        value={text}
        disabled={disabled}
        onChange={(event) => setText(event.target.value)}
      />
      {file ? (
        <span className="workshop-new-state__file">
          <CanvasIcon path={WORKSHOP_ICONS.image} size={16} />
          {fillTemplate(labels.ATTACHED, { name: file.name })}
          <button
            type="button"
            aria-label={labels.REMOVE_IMAGE}
            disabled={disabled}
            onClick={() => setFile(null)}
          >
            <CanvasIcon
              path={WORKSHOP_ICONS.close}
              size={14}
              strokeWidth={2.4}
            />
          </button>
        </span>
      ) : null}
      <div className="workshop-new-state__actions">
        <button
          type="button"
          className="workshop-new-state__attach"
          disabled={disabled}
          onClick={() => fileRef.current && fileRef.current.click()}
        >
          <CanvasIcon path={WORKSHOP_ICONS.image} size={16} />
          {labels.ATTACH}
        </button>
        {busy ? (
          <span className="workshop-new-state__busy">
            <CanvasIcon path={WORKSHOP_ICONS.busy} size={16} />
            {labels.BUSY}
          </span>
        ) : null}
        <span className="workshop-new-state__spacer" />
        <button
          type="button"
          className="workshop-new-state__cancel"
          disabled={busy}
          onClick={onCancel}
        >
          {labels.CANCEL}
        </button>
        <button
          type="button"
          className="workshop-button workshop-button--primary workshop-button--small"
          disabled={!ready}
          onClick={submit}
        >
          {labels.SUBMIT}
        </button>
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        className="workshop__file"
        onChange={pickFile}
      />
    </section>
  );
};

WorkshopNewState.propTypes = {
  labels: PropTypes.object.isRequired,
  busy: PropTypes.bool,
  disabled: PropTypes.bool,
  onPropose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

WorkshopNewState.defaultProps = {
  busy: false,
  disabled: false,
};

export default WorkshopNewState;
